export interface OperatorConfig {
    label: string;
    value: string;
    hasValue: boolean;
    isDynamic?: boolean; // Nova propriedade
}

export const FIELD_COMPARISON_OPERATORS: OperatorConfig[] = [
    { label: "equals field", value: "eq_field", hasValue: true },
    { label: "does not equal field", value: "neq_field", hasValue: true },
];

export const OPERATORS_BY_TYPE: Record<string, OperatorConfig[]> = {
    UUID: [
        { label: "is", value: "eq", hasValue: true },
        { label: "is one of", value: "in", hasValue: true },
        { label: "is (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
    ],

    BOOLEAN: [
        { label: "is", value: "eq", hasValue: true },
        { label: "is (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
    ],

    TEXT: [
        { label: "equals", value: "eq", hasValue: true },
        { label: "not equals", value: "neq", hasValue: true },
        { label: "contains", value: "contains", hasValue: true },
        { label: "does not contain", value: "not_contains", hasValue: true },
        { label: "starts with", value: "stw", hasValue: true },
        { label: "ends with", value: "edw", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
        { label: "equals (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
        { label: "not equals (dynamic)", value: "neq_dynamic", hasValue: true, isDynamic: true },
    ],

    // Mesmo conjunto de operadores de TEXT — mantido em sincronia com
    // QUERY_OPERATORS_BY_TYPE["TRANSLATABLE_TEXT"] em
    // app/backend/app/services/query_engine/validator.rb.
    TRANSLATABLE_TEXT: [
        { label: "equals", value: "eq", hasValue: true },
        { label: "not equals", value: "neq", hasValue: true },
        { label: "contains", value: "contains", hasValue: true },
        { label: "does not contain", value: "not_contains", hasValue: true },
        { label: "starts with", value: "stw", hasValue: true },
        { label: "ends with", value: "edw", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
        { label: "equals (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
        { label: "not equals (dynamic)", value: "neq_dynamic", hasValue: true, isDynamic: true },
    ],

    TABLE_NAME: [
        { label: "is", value: "eq", hasValue: true },
        { label: "is not", value: "neq", hasValue: true },
        { label: "is one of", value: "in", hasValue: true },
        { label: "contains", value: "contains", hasValue: true },
        { label: "starts with", value: "stw", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
        { label: "is (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
        { label: "is not (dynamic)", value: "neq_dynamic", hasValue: true, isDynamic: true },
    ],

    INTEGER: [
        { label: "equals", value: "eq", hasValue: true },
        { label: "not equals", value: "neq", hasValue: true },
        { label: "is one of", value: "in", hasValue: true },
        { label: "greater than", value: "gt", hasValue: true },
        { label: "greater or equal", value: "gte", hasValue: true },
        { label: "less than", value: "lt", hasValue: true },
        { label: "less or equal", value: "lte", hasValue: true },
        { label: "between", value: "between", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
        { label: "equals (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
        { label: "not equals (dynamic)", value: "neq_dynamic", hasValue: true, isDynamic: true },
        { label: "greater than (dynamic)", value: "gt_dynamic", hasValue: true, isDynamic: true },
        { label: "greater or equal (dynamic)", value: "gte_dynamic", hasValue: true, isDynamic: true },
        { label: "less than (dynamic)", value: "lt_dynamic", hasValue: true, isDynamic: true },
        { label: "less or equal (dynamic)", value: "lte_dynamic", hasValue: true, isDynamic: true },
    ],

    DECIMAL: [
        { label: "equals", value: "eq", hasValue: true },
        { label: "not equals", value: "neq", hasValue: true },
        { label: "is one of", value: "in", hasValue: true },
        { label: "greater than", value: "gt", hasValue: true },
        { label: "greater or equal", value: "gte", hasValue: true },
        { label: "less than", value: "lt", hasValue: true },
        { label: "less or equal", value: "lte", hasValue: true },
        { label: "between", value: "between", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
        { label: "equals (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
        { label: "not equals (dynamic)", value: "neq_dynamic", hasValue: true, isDynamic: true },
        { label: "greater than (dynamic)", value: "gt_dynamic", hasValue: true, isDynamic: true },
        { label: "greater or equal (dynamic)", value: "gte_dynamic", hasValue: true, isDynamic: true },
        { label: "less than (dynamic)", value: "lt_dynamic", hasValue: true, isDynamic: true },
        { label: "less or equal (dynamic)", value: "lte_dynamic", hasValue: true, isDynamic: true },
    ],

    CURRENCY: [
        { label: "equals", value: "eq", hasValue: true },
        { label: "not equals", value: "neq", hasValue: true },
        { label: "is one of", value: "in", hasValue: true },
        { label: "greater than", value: "gt", hasValue: true },
        { label: "greater or equal", value: "gte", hasValue: true },
        { label: "less than", value: "lt", hasValue: true },
        { label: "less or equal", value: "lte", hasValue: true },
        { label: "between", value: "between", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
        { label: "equals (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
        { label: "not equals (dynamic)", value: "neq_dynamic", hasValue: true, isDynamic: true },
        { label: "greater than (dynamic)", value: "gt_dynamic", hasValue: true, isDynamic: true },
        { label: "greater or equal (dynamic)", value: "gte_dynamic", hasValue: true, isDynamic: true },
        { label: "less than (dynamic)", value: "lt_dynamic", hasValue: true, isDynamic: true },
        { label: "less or equal (dynamic)", value: "lte_dynamic", hasValue: true, isDynamic: true },
    ],

    DATE: [
        { label: "on", value: "on", hasValue: true },
        { label: "not on", value: "not_on", hasValue: true },
        { label: "last", value: "relative_last", hasValue: true },
        { label: "next", value: "relative_next", hasValue: true },
        { label: "equals", value: "eq", hasValue: true },
        { label: "not equals", value: "neq", hasValue: true },
        { label: "is one of", value: "in", hasValue: true },
        { label: "before", value: "lt", hasValue: true },
        { label: "before or equal", value: "lte", hasValue: true },
        { label: "after", value: "gt", hasValue: true },
        { label: "after or equal", value: "gte", hasValue: true },
        { label: "between", value: "between", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
        { label: "on (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
        { label: "not on (dynamic)", value: "neq_dynamic", hasValue: true, isDynamic: true },
        { label: "before (dynamic)", value: "lt_dynamic", hasValue: true, isDynamic: true },
        { label: "after (dynamic)", value: "gt_dynamic", hasValue: true, isDynamic: true },
    ],

    DATETIME: [
        { label: "on", value: "on", hasValue: true },
        { label: "not on", value: "not_on", hasValue: true },
        { label: "last", value: "relative_last", hasValue: true },
        { label: "next", value: "relative_next", hasValue: true },
        { label: "exactly at", value: "eq", hasValue: true },
        { label: "not exactly at", value: "neq", hasValue: true },
        { label: "is one of", value: "in", hasValue: true },
        { label: "before", value: "lt", hasValue: true },
        { label: "before or equal", value: "lte", hasValue: true },
        { label: "after", value: "gt", hasValue: true },
        { label: "after or equal", value: "gte", hasValue: true },
        { label: "between", value: "between", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
        { label: "on (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
        { label: "not on (dynamic)", value: "neq_dynamic", hasValue: true, isDynamic: true },
        { label: "before (dynamic)", value: "lt_dynamic", hasValue: true, isDynamic: true },
        { label: "after (dynamic)", value: "gt_dynamic", hasValue: true, isDynamic: true },
    ],

    TIME: [
        { label: "at", value: "eq", hasValue: true },
        { label: "not at", value: "neq", hasValue: true },
        { label: "is one of", value: "in", hasValue: true },
        { label: "before", value: "lt", hasValue: true },
        { label: "after", value: "gt", hasValue: true },
        { label: "between", value: "between", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
        { label: "at (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
        { label: "not at (dynamic)", value: "neq_dynamic", hasValue: true, isDynamic: true },
        { label: "before (dynamic)", value: "lt_dynamic", hasValue: true, isDynamic: true },
        { label: "after (dynamic)", value: "gt_dynamic", hasValue: true, isDynamic: true },
    ],

    CHOICE: [
        { label: "is", value: "eq", hasValue: true },
        { label: "is not", value: "neq", hasValue: true },
        { label: "is one of", value: "in", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
        { label: "is (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
        { label: "is not (dynamic)", value: "neq_dynamic", hasValue: true, isDynamic: true },
    ],

    REFERENCE: [
        { label: "is", value: "eq", hasValue: true },
        { label: "is not", value: "neq", hasValue: true },
        { label: "is one of", value: "in", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
        { label: "is (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
        { label: "is not (dynamic)", value: "neq_dynamic", hasValue: true, isDynamic: true },
        { label: "is in the inheritance chain of", value: "in_table_chain", hasValue: true },
        { label: "is in the inheritance chain of (dynamic)", value: "in_table_chain_dynamic", hasValue: true, isDynamic: true },
        { label: "is an ancestor of", value: "in_ancestor_chain", hasValue: true },
        { label: "is an ancestor of (dynamic)", value: "in_ancestor_chain_dynamic", hasValue: true, isDynamic: true },
    ],

    DYNAMIC_REFERENCE: [
        { label: "is", value: "eq", hasValue: true },
        { label: "is not", value: "neq", hasValue: true },
        { label: "is one of", value: "in", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
        { label: "is (dynamic)", value: "eq_dynamic", hasValue: true, isDynamic: true },
        { label: "is not (dynamic)", value: "neq_dynamic", hasValue: true, isDynamic: true },
    ],

    CODE: [
        { label: "contains", value: "contains", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
    ],

    RICH_HTML: [
        { label: "contains", value: "contains", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
    ],

    PERMISSION_ARRAY: [
        { label: "contains", value: "contains", hasValue: true },
        { label: "is one of", value: "in", hasValue: true },
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
    ],

    CONDITION: [
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
    ],

    PASSWORD: [
        { label: "is empty", value: "empty", hasValue: false },
        { label: "is not empty", value: "not_empty", hasValue: false },
    ],
};

OPERATORS_BY_TYPE.NUMBER = OPERATORS_BY_TYPE.DECIMAL;

export function getOperatorConfig(
    fieldType: string,
    operator: string
) {
    return OPERATORS_BY_TYPE[fieldType]?.find(
        (op) => op.value === operator
    );
}

export function isDynamicOperator(operator: string): boolean {
    return operator?.endsWith('_dynamic') || false;
}

export function isFieldComparisonOperator(operator: string): boolean {
    return operator === "eq_field" || operator === "neq_field";
}

export function toDynamicOperator(operator: string): string {
    if (!operator || isDynamicOperator(operator)) {
        return operator;
    }

    return `${operator}_dynamic`;
}

export function toStaticOperator(operator: string): string {
    if (!operator) {
        return operator;
    }

    return operator.replace(/_dynamic$/, '');
}

/**
 * Detecta se um valor é dinâmico baseado no formato
 * Formatos suportados: ${field}, {{user.id}}, $form.field
 */
export function isDynamicValue(value: any): boolean {
    if (typeof value !== 'string') return false;

    // Verifica se contém ${...}, {{...}} ou o prefixo $form.
    return /\$\{.+\}/.test(value) || /\{\{.+\}\}/.test(value) || value.indexOf('$form.') === 0;
}

/**
 * Verifica se deve renderizar como campo dinâmico
 * Considera tanto operador _dynamic quanto valor dinâmico
 */
export function shouldUseDynamicField(operator: string, value: any): boolean {
    return isDynamicOperator(operator) || isDynamicValue(value);
}
